import Wrapper from './Wrapper';
import RouteWrapper from '../dashboard/routes';
import { PublicRoutes } from './routeConfig';
import { useEffect, useState } from 'react';
import { MobileLogin } from './MobileLogin';
import { connect } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { updateFirstTimeSettings } from '../../redux-store/actions/login';
import { isMobile } from '../quick-links/faq';

function AuthRoutes(props: any) {
    const { path } = props.match;
    const { appTourVisited } = props;
    const _isMobile = isMobile(window.navigator.userAgent);
    if (!appTourVisited && _isMobile) {
        return <MobileLogin {...props} />;
    }
    return (
        <Wrapper {...props}>
            <RouteWrapper routes={PublicRoutes} initPath={`/signin`} matchPath={path} />
        </Wrapper>
    );
}
export default connect(
    ({ authReducer }: RootStateType) => ({ appTourVisited: authReducer.appTourVisited }),
    { updateFirstTimeSettings },
)(AuthRoutes);
